<script lang="ts" setup>
import { ref, inject } from 'vue';
import { CONTEXT_KEY, type Context } from './types';

defineOptions({
  name: 'CarouselPrevTrigger',
});

const context = inject<Context>(CONTEXT_KEY);

if (!context) {
  console.error('Carousel.PrevTrigger 必须在 Carousel.Root 组件内部使用');
}

const canScrollPrev = context?.canScrollPrev ?? ref(false);
const scrollPrev = context?.scrollPrev ?? (() => {});
</script>

<template>
  <button
    type="button"
    class="embla__button embla__button--prev"
    data-scope="carousel"
    data-part="prev-trigger"
    aria-label="Previous Slide"
    :disabled="!canScrollPrev"
    @click="scrollPrev"
  >
    <slot></slot>
  </button>
</template>

<style lang="scss" scoped>
</style>
